import { render } from "./NewMixModal.vue?vue&type=template&id=6130a16a&ts=true"
import script from "./NewMixModal.vue?vue&type=script&lang=ts"
export * from "./NewMixModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__